import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {PledgeStatusType} from '../../../../services/api.client';
import {PaymentProcessingFormComponent} from '../PaymentProcessingFormComponent';
import {ShiftPledgeReportSummary} from '../../../../services/api.client';

@Component({
    selector: 'pledgesSummary',
    templateUrl: './PendingPledgesSummaryComponent.html',
    styleUrls: ['./PendingPledgesSummaryComponent.scss'],
    standalone: false
})

export class PendingPledgesSummaryComponent implements AfterViewInit {
    private readonly _reports$ = new BehaviorSubject<ShiftPledgeReportSummary[]>(null);
    reports$: Observable<ShiftPledgeReportSummary[]> = this._reports$.asObservable();
    reports: ShiftPledgeReportSummary[];

    @ViewChild(PaymentProcessingFormComponent)
    form: PaymentProcessingFormComponent;

    submitReport(): void {
        this.form.submitPendingPledgesSummary()?.subscribe({next: (reports) => this._reports$.next(reports), error: () => {}});
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.form.form.get('displayPledgeStatus')?.reset(PledgeStatusType.Pending, {disabled: false}), 0);
    }
}
